const THIRD_PARTY_SERVICES = {
  ZUORA: 'ZUORA',
  ADYEN: 'ADYEN'
};
export { THIRD_PARTY_SERVICES };